import { Pipe, PipeTransform } from '@angular/core';

import { ImpactDataItem } from '../modules/widget/services/chart-report/chart-report-impact/chart-report-impact';
import { Comment } from '../providers/bridge-api/dashboard.service';

@Pipe({
  name: 'getAreaComments',
  pure: true,
  standalone: false,
})
export class GetAreaCommentsPipe implements PipeTransform {
  transform(
    value: ImpactDataItem,
    commentsByPointId: Map<string, Comment>,
    widgetsHidden: boolean
  ) {
    if (widgetsHidden) {
      return false;
    }
    return commentsByPointId.has(value.label);
  }
}
